const getParahubListRequest = (payload) => {
    return {
        enabled: payload?.enabled,
    };
};

export default getParahubListRequest;
